import { render, staticRenderFns } from "./OfficeServiceGroupDialog.vue?vue&type=template&id=21a2bd58"
import script from "./OfficeServiceGroupDialog.vue?vue&type=script&lang=js"
export * from "./OfficeServiceGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports